import { uniqWith } from 'rambda';
import { SearchResponse, Hit } from '@algolia/client-search';
import { Product } from '../../../common';

export function deDuplicateProducts(response: SearchResponse<Product>): Hit<Product>[] {
  return uniqWith((a, b) => a.productId === b.productId, response?.hits ?? []) as Hit<Product>[];
}

export function sortAsProvided(products: Hit<Product>[], productIdsOrder: Product['productId'][]): Hit<Product>[] {
  return [...(products || [])].sort((a, b) => {
    return (productIdsOrder || []).indexOf(a.productId) - (productIdsOrder || []).indexOf(b.productId);
  });
}
